import { createContext, useContext } from 'react'
import PropTypes from 'prop-types'

const AppContext = createContext()

export const AppContextProvider = (props) => {
  return (
    <AppContext.Provider value={props.value}>
      {props.children}
    </AppContext.Provider>
  )
}

AppContextProvider.propTypes = {
  value: PropTypes.shape({
    currentUser: PropTypes.object
  }),
  children: PropTypes.node
}

export const useAppContext = () => useContext(AppContext)
